import { LayoutProvider } from '@ps/web-sports-utils';
import React from 'react';

import ApolloClientProvider from '@swf/core/providers/ApolloClientProvider';
import RefsProvider from '@swf/core/providers/RefsProvider';

import { LiveDataProvider } from './LiveDataProvider';
import MarketPollingProvider from './MarketPollingProvider';
import OddsFormatProvider from './OddsFormatProvider';
import { SettledDataProvider } from './SettledDataProvider';

const SportsProviders: React.FC<React.PropsWithChildren> = ({ children }) => (
  <ApolloClientProvider httpLinkUri="/sports/web/gbp/sca/graphql">
    <RefsProvider>
      <LiveDataProvider>
        <SettledDataProvider>
          <MarketPollingProvider>
            <OddsFormatProvider>
              <LayoutProvider>{children}</LayoutProvider>
            </OddsFormatProvider>
          </MarketPollingProvider>
        </SettledDataProvider>
      </LiveDataProvider>
    </RefsProvider>
  </ApolloClientProvider>
);

export default SportsProviders;
